import { FooterLink } from '@core/shared';
import { Container } from '@core/ui';
import { Content } from '../Content';
import { TopHeader } from '../TopHeader';

export const LayoutWhitelabel = ({ logoUrl, logoText, footerLinks }: { logoUrl: string; logoText: string; footerLinks: FooterLink[] }) => {
    return (
        <Container classNames="menu-top">
            <TopHeader logoUrl={logoUrl} logoText={logoText} />
            <Content footerLinks={footerLinks} />
        </Container>
    );
};
